import { Chapter } from "@/components/Chapter";
import { Reveal } from "@/components/Reveal";
import { STYLES } from "@/data/content";

const LIVING = ["Comfort that lasts", "Function that adapts", "Spaces that evolve with you"];

const StyleGrid = () => (
    <div className="mt-12 grid grid-cols-1 gap-px border border-wood/10 bg-wood/10 sm:grid-cols-2 lg:grid-cols-4">
        {STYLES.map((s, i) => (
            <Reveal key={s.number} delay={0.08 * i} className="h-full">
                <div className="group flex h-full flex-col bg-ivory p-8 transition-colors duration-500 hover:bg-night">
                    <span className="font-mono text-xs text-terra transition-colors duration-500 group-hover:text-gold">{s.number}</span>
                    <h3 className="mt-6 font-serif text-xl font-medium leading-snug text-ink transition-colors duration-500 group-hover:text-ivory">{s.title}</h3>
                    <p className="mt-3 text-sm font-light leading-relaxed text-mute transition-colors duration-500 group-hover:text-ivory/60">{s.text}</p>
                </div>
            </Reveal>
        ))}
    </div>
);

const Principles = () => (
    <div className="mt-16 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
        <Reveal delay={0.1} className="space-y-6 text-base font-light leading-relaxed text-mute sm:text-lg">
            <h3 className="font-serif text-xl font-medium text-ink sm:text-2xl">Mastery of Color, Material & Theme</h3>
            <p>
                Design lives in nuance. From subtle tonal palettes to bold, dramatic contrasts—every
                choice of color, texture, and material is made with intent. We understand balance.
            </p>
            <p className="font-serif italic text-wood">We create aesthetics—but we never overdesign.</p>
        </Reveal>
        <Reveal delay={0.2} className="space-y-6 text-base font-light leading-relaxed text-mute sm:text-lg">
            <h3 className="font-serif text-xl font-medium text-ink sm:text-2xl">Designed for Living, Not Display</h3>
            <p>
                There is a difference between designing a hotel, a clubhouse, and a home. We design
                for real living—because a home should not feel staged, it should feel lived in.
            </p>
            <ul className="space-y-3">
                {LIVING.map((l) => (
                    <li key={l} className="flex items-center gap-3 text-sm text-ink">
                        <span className="h-1.5 w-1.5 rotate-45 bg-gold" />
                        {l}
                    </li>
                ))}
            </ul>
        </Reveal>
    </div>
);

export const DesignLanguage = () => (
    <Chapter number="05" label="Our Design Language" title="Global Influences, Personally Interpreted" testid="manifesto-chapter-06">
        <Reveal delay={0.15} className="max-w-2xl text-base font-light leading-relaxed text-mute sm:text-lg">
            <p>
                Our work draws from diverse design philosophies—interpreted, not applied. We don’t
                follow styles; we translate them into something personal.
            </p>
        </Reveal>
        <StyleGrid />
        <Principles />
    </Chapter>
);
